<template>
   <header>
      <div class="topbar d-flex align-items-center">
         <nav class="navbar navbar-expand">
            <div class="mobile-toggle-menu pe-4" @click="toggleMobileMenu"><i class='bx bx-menu'></i></div>
            <div class="empresa-navbar-wrapper dropdown" v-if="empresa">
               <button type="button" class="empresa-navbar empresa-navbar-button dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Alternar empresa" :disabled="trocandoEmpresa"><span class="empresa-navbar-content">
                  <p class="empresa-nome mb-0">{{ empresa.businessName }}</p>
                  <p class="empresa-cnpj mb-0">
                     {{ cnpjFormatado }}
                     <span v-if="ieEmpresa"> | IE: {{ ieEmpresa }}</span>
                     <span v-if="localizacaoEmpresa"> | {{ localizacaoEmpresa }}</span>
                  </p>
               </span></button>
               <div class="dropdown-menu empresa-navbar-menu">
                  <h6 class="dropdown-header">Alternar empresa</h6>
                  <div class="empresa-navbar-filter px-3 pb-2" @click.stop>
                     <input v-model.trim="filtroEmpresa" type="search" class="form-control form-control-sm" placeholder="Filtrar por nome ou CNPJ" aria-label="Filtrar empresas por nome ou CNPJ" @keydown.enter.prevent />
                  </div>
                  <ul class="empresa-navbar-lista list-unstyled mb-0">
                     <li v-for="opcao in empresasFiltradas" :key="opcao.id"><button type="button" class="dropdown-item empresa-navbar-option" :class="{ active: String(opcao.id) === String(empresa.id) }" :disabled="trocandoEmpresa || !planoEmpresaAtivo(opcao) || String(opcao.id) === String(empresa.id)" :title="[opcao.businessName || opcao.tradeName, documentoEmpresa(opcao), localizacaoOpcao(opcao)].filter(Boolean).join(' · ')" @click="alternarEmpresa(opcao)"><span><strong>{{ opcao.businessName || opcao.tradeName }}</strong><small>{{ documentoEmpresa(opcao) }}<span v-if="localizacaoOpcao(opcao)"> · {{ localizacaoOpcao(opcao) }}</span></small></span><i v-if="String(opcao.id) === String(empresa.id)" class="far fa-check" aria-label="Empresa atual"></i><small v-else-if="!planoEmpresaAtivo(opcao)">Indisponível</small></button></li>
                     <li v-if="!empresasFiltradas.length" class="dropdown-item-text text-muted py-3" role="status">{{ empresasAcessiveis.length ? 'Nenhuma empresa encontrada.' : 'Nenhuma empresa disponível.' }}</li>
                  </ul>
               </div>
            </div>
            <div class="search-bar flex-grow-1"></div>
            <div class="top-menu ms-auto">
               <div class="topbar-shortcuts">
                  <button type="button" class="btn topbar-shortcut" @click="abrirTutoriais"><i class="far fa-play-circle me-1"></i>Tutoriais</button>
                  <button type="button" class="btn topbar-shortcut" @click="abrirSuporte"><i class="far fa-headset me-1"></i>Suporte</button>
               </div>
            </div>
            <div class="user-box dropdown user-box-compact">
               <a class="d-flex align-items-center nav-link dropdown-toggle dropdown-toggle-nocaret" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" :title="dadosUsuario.fullName || primeiroNomeUsuario">
                  <img :src="avatarUsuario" @error="imageError" class="user-img border-theme border-2" ref="avatar" alt="Foto do usuário">
                  <div class="user-info ps-2">
                     <p class="user-name mb-0">{{ primeiroNomeUsuario }}</p>
                  </div>
               </a>
               <ul class="dropdown-menu dropdown-menu-end">
                  <li><a class="dropdown-item" href="javascript:;" @click="abrirPerfil"><i class='bx bx-user'></i><span>Perfil</span></a></li>
                  <li><a class="dropdown-item" href="javascript:;" @click="irParaSelecaoEmpresa"><i class='bx bx-building'></i><span>Empresas</span></a></li>
                  <li><a class="dropdown-item" href="javascript:;" @click="deslogar"><i class='bx bx-log-out-circle'></i><span>Deslogar</span></a></li>
               </ul>
            </div>
            <button type="button" class="btn topbar-logout-shortcut" title="Sair do sistema" aria-label="Sair do sistema" @click="deslogar">
               <i class="bx bx-log-out-circle" aria-hidden="true"></i>
            </button>
         </nav>
      </div>
   </header>
</template>

<script>

import { mapState } from 'vuex'
import $ from 'jquery'
import { formatarCnpjAlfanumerico } from '@/utils/documentos'
import avatarPadrao from '@/assets/images/avatar.png'
import { resolverUrlArquivo } from '@/utils/produtoImagem'

export default {
	name: 'MenuNavBar',
   data() { return { trocandoEmpresa: false, filtroEmpresa: '' } },
   computed: {
      empresasAcessiveis() { return (this.dadosUsuario?.companies || []).filter(empresa => empresa.status === 'ACTIVE') },
      empresasFiltradas() {
         const nome = String(this.filtroEmpresa || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
         const documento = nome.replace(/[^a-z0-9]/g, '')
         return this.empresasAcessiveis.filter(empresa => {
            const nomes = [empresa.businessName, empresa.tradeName].filter(Boolean).join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
            const cnpj = String(empresa.cnpj || '').replace(/[^a-z0-9]/gi, '').toLowerCase()
            return !nome || nomes.includes(nome) || (documento && cnpj.includes(documento))
         })
      },
      ... mapState({
         dadosUsuario: state => state.dadosUsuario,
         empresa: state => state.empresa,
         urlRest: state => state.urlRest
      }),
      avatarUsuario() {
         return resolverUrlArquivo(this.dadosUsuario?.avatar, this.urlRest) || avatarPadrao
      },
      primeiroNomeUsuario() {
         const nomeCompleto = String(this.dadosUsuario?.fullName || this.dadosUsuario?.name || '').trim()
         return nomeCompleto ? nomeCompleto.split(/\s+/)[0] : 'Usuário'
      },
      cnpjFormatado() {
         if (!this.empresa || !this.empresa.cnpj) {
            return ''
         }
         return formatarCnpjAlfanumerico(this.empresa.cnpj) || this.empresa.cnpj
      },
      localizacaoEmpresa() {
         if (!this.empresa) {
            return ''
         }
         const cidade = this.empresa.city ? String(this.empresa.city).trim() : ''
         const uf = this.empresa.state ? String(this.empresa.state).trim() : ''
         if (!cidade && !uf) {
            return ''
         }
         if (cidade && uf) {
            return `${cidade} - ${uf}`
         }
         return cidade || uf
      },
      ieEmpresa() {
         if (!this.empresa || !this.empresa.stateRegistration) {
            return ''
         }
         return String(this.empresa.stateRegistration).trim()
      }
   },
   methods: {
      localizacaoOpcao(empresa) { return [empresa.city, empresa.state].map(valor => String(valor || '').trim()).filter(Boolean).join(' / ') },
      documentoEmpresa(empresa) { return formatarCnpjAlfanumerico(empresa.cnpj) || empresa.cnpj || '' },
      planoEmpresaAtivo(empresa) { return ['ACTIVE', 'GRACE_PERIOD', 'PENDING_ACTIVATION'].includes(empresa.subscriptionStatus) },
      async alternarEmpresa(opcao) {
         const empresa = this.empresasAcessiveis.find(item => String(item.id) === String(opcao.id))
         if (this.trocandoEmpresa || !empresa || !this.planoEmpresaAtivo(empresa) || String(empresa.id) === String(this.empresa?.id)) return
         this.trocandoEmpresa = true
         try {
            // Navegar antes de mudar o contexto respeita as proteções de lançamentos não salvos.
            if (this.$route.path !== '/paginaInicial') await this.$router.push('/paginaInicial')
            await this.$store.dispatch('setEmpresa', empresa)
         } catch (error) {
            if (!error?.type) this.$toast.fire({ icon: 'error', title: 'Não foi possível alternar a empresa.' })
         } finally { this.trocandoEmpresa = false }
      },
      imageError : function (e) {
         this.$store.dispatch('imageError', e)
      },
      deslogar : function () {
			return this.$editing.leave(null, () => this.$store.dispatch('deslogar'))
      },
      irParaSelecaoEmpresa : function () {
         return this.$editing.leave(null, () => this.$store.dispatch('trocarEmpresa'))
      },
      abrirPerfil : function () {
         if (this.$route.path !== '/perfil') { this.$router.push('/perfil').catch(() => {}) }
      },
      abrirTutoriais : function () {
         if (this.$route.path !== '/tutoriais') {
            this.$router.push('/tutoriais').catch(() => {})
         }
      },
      abrirSuporte : function () {
         this.$toast.fire({ icon: 'info', title: 'Atalho de suporte preparado no frontend.' })
      },
      toggleMobileMenu : function () {
         const minimizada = !$(".wrapper").hasClass("toggled");
         const $wrapper = $(".wrapper");
         const $sidebar = $(".sidebar-wrapper");
         localStorage.setItem('jair_sidebar_collapsed', minimizada ? '1' : '0');
         $sidebar.off("mouseenter.sidebar-state mouseleave.sidebar-state");
         if (minimizada) {
            $wrapper.addClass("toggled");
            $sidebar.on("mouseenter.sidebar-state", function () {
               $wrapper.addClass("sidebar-hovered");
            });
            $sidebar.on("mouseleave.sidebar-state", function () {
               $wrapper.removeClass("sidebar-hovered");
            });
            return;
         }
         $wrapper.removeClass("toggled sidebar-hovered");
      }
   }
}

</script>

<style scoped>

.empresa-navbar-wrapper {
   display: flex;
   align-items: center;
   gap: 10px;
   min-width: 0;
}
.empresa-navbar-button { display:flex; align-items:center; gap:14px; padding:7px 12px; border:1px solid #dce3ed; border-radius:7px; background:#f7f9fc; color:#334155; text-align:left; }
.empresa-navbar-button:hover,.empresa-navbar-button:focus-visible { border-color:var(--color-theme); background:#eef3ff; }
.empresa-navbar-content { min-width:0; }
.empresa-navbar-menu { width:min(430px, calc(100vw - 48px)); }
.empresa-navbar-lista { max-height:min(290px, calc(100dvh - 190px)); overflow-y:auto; overscroll-behavior:contain; }
.empresa-navbar-option { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:10px 16px; height:58px; }
.empresa-navbar-option>span { min-width:0; }
.empresa-navbar-option strong,.empresa-navbar-option small { display:block; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.empresa-navbar-option>span { flex:1; }
.empresa-navbar-option>small,.empresa-navbar-option>i { flex-shrink:0; }
.empresa-navbar-option small { font-size:11px; opacity:.8; }
.empresa-navbar {
   min-width: 0;
   max-width: 380px;
   line-height: 1.2;
}
.empresa-nome {
   margin-bottom: 3px !important;
   font-weight: 600;
   font-size: 14px;
   color: inherit;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}
.empresa-cnpj {
   font-size: 11px;
   color: #6c757d;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}
.topbar-shortcuts {
   display: flex;
   align-items: center;
   gap: 8px;
}
.topbar-shortcut {
   height: 34px;
   padding: 0 12px;
   border: 1px solid color-mix(in srgb, var(--color-theme) 22%, #0000);
   color: var(--color-theme);
   background: color-mix(in srgb, var(--color-theme) 5%, #fff);
   font-size: 12px;
   font-weight: 600;
   border-radius: 6px;
}
.topbar-shortcut:hover {
   color: #fff;
   background: var(--color-theme);
}
.user-box-compact {
   max-width: 175px;
   min-width: 125px;
   padding: 0 5px 0 10px;
}
.user-box-compact .nav-link {
   min-width: 0;
   width: 100%;
}
.user-box-compact .user-info {
   min-width: 0;
   max-width: 92px;
}
.user-box-compact .user-name,
.user-box-compact .designattion {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}
.topbar-logout-shortcut {
   align-items: center;
   background: #fff;
   border: 1px solid #dce3ed;
   border-radius: 6px;
   color: #64748b;
   display: inline-flex;
   flex: 0 0 34px;
   height: 34px;
   justify-content: center;
   margin-right: 10px;
   padding: 0;
   width: 34px;
}
.topbar-logout-shortcut:hover,
.topbar-logout-shortcut:focus-visible {
   background: #dc3545;
   border-color: #dc3545;
   color: #fff;
}

@media (max-width: 991px) {
   .topbar-shortcuts {
      display: none;
   }
   .user-box-compact {
      min-width: auto;
      max-width: 58px;
   }
   .user-box-compact .user-info {
      display: none;
   }
}

</style>
